import styled from "styled-components";
import { device } from "../device";

export const ReasonsSwiperContainer = styled.section`
  background-color: ${(props) => props.theme.colors.lightBg};
  color: ${(props) => props.theme.colors.fontBlack};
  overflow: hidden;
  padding-top: 80px;
  padding-bottom: 80px;

  h2 {
    margin-top: 0;
    color: ${(props) => props.theme.colors.fontBlack};
    font-size: 28px;
    font-weight: 700;
    text-align: left;

    @media ${device.tablet} {
      font-size: 42px;
    }
  }
  .buttonwrapper {
    padding: 0 20px;

    a,
    button {
      margin-top: 32px;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }

    @media ${device.tablet} {
      a,
      button {
        width: auto;
      }
    }
  }
`;

export const FeaturesSectionContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 365px;
  max-width: 100%;
  @media ${device.tablet} {
    width: 692px;
  }
  @media ${device.laptop} {
    width: 1080px;
  }
`;
export const FeaturesSectionSwiperContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  overflow: visible;
  width: 365px;
  @media ${device.tablet} {
    width: 692px;
  }
  @media ${device.laptop} {
    width: 1080px;
  }
`;

export const SwiperWrapper = styled.div`
  .swiper {
    width: 100%;
    padding-top: 0;
    padding-bottom: 50px;
    overflow: visible;
  }

  .application-swiper {
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 309px;
      height: 380px;
      margin-right: 20px;

      @media ${device.tablet} {
        width: 500px;
      }
    }
  }
  .jobs-swiper {
    margin-bottom: 64px;
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 309px;
      height: auto;
      margin-right: 20px;
      margin-bottom: 20px;

      @media ${device.tablet} {
        width: 500px;
      }
    }
  }
  .reasons-swiper {
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 309px;
      height: 500px;
      margin-right: 20px;

      @media ${device.tablet} {
        width: 400px;
      }
    }
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }

  .swiper-pagination-bullet-active {
    background: ${(props) => props.theme.colors.primary} !important;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets
    .swiper-pagination-bullet {
    background-color: #6e6e73;
  }
`;
